import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useLocation} from "react-router-dom";
import {Tab, Tabs} from '../../components/common/TabCustom';

import { ALERT_TYPE, ESTADOS_FIRMA, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import {APIS} from '../../config/apis';
import {ServerRequest} from '../../utils/apiweb';
import {useEntidad, useForm, useNav, useReporte, useNavigateWithFilters, useUnsavedChangesGuard} from '../../components/hooks';
import {
    Loading,
    TableCustom,
    SectionHeading,
    DatePickerCustom,
    InputNumber,
    InputCuenta,
    InputLista,
    MessageModal,
    Modal,
    Accordion,
    FormLabel,
    Select
} from '../../components/common';
import {FooterButtonVolver} from '../../components/buttons/FooterButtonVolver/FooterButtonVolver';
import {CloneObject, OpenObjectURL} from '../../utils/helpers';
import {getDateId, getDateNow, iif} from '../../utils/convert';
import CertificadosApremioItemGrid from '../../components/controls/CertificadosApremioItemGrid';
import CertificadoApremioPersonaGrid from '../../components/controls/CertificadoApremioPersonaGrid';
import DataTaggerFormRedux from '../../components/controls/DataTaggerFormRedux';
import {getDateToString} from '../../utils/convert';
import {CertificadoApremioTituloGrid, ReasignarApremioModal} from './components'
import {usePermissions} from '../../components/hooks/usePermissions';
import {PERMISSIONS} from '../../consts/permissions';


function CertificadoApremioView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const previousFilters = location.state?.filters;

    //variables
    const entityInit = {
        certificadoApremio: {
            id: 0,
            idApremio: 0,
            idEstadoCertificadoApremio: 0,
            numero: '',
            idCuenta: 0,
            idInspeccion: 0,
            montoTotal: 0,
            fechaCertificado: null,
            fechaCalculo: null,
            fechaNotificacion: null,
            fechaRecepcion: null,
            idFirmaDigitalTituloEjecutivo: null,
            idEstadoFirmaTituloEjecutivo: null,
            pagoHabilitado: false
        },
        certificadoApremioItems: [],
        certificadoApremioPersonas: [],
        archivos: [],
        observaciones: [],
        etiquetas: []
    };

    //hooks
    let navigate = useNav()
    const navigateWithFilters = useNavigateWithFilters(() => previousFilters || null);

    const [state, setState] = useState({
        processKey: `CertificadoApremio_${params.id ?? 0}_${getDateId()}`,
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        showMenu: false,
        showMessage: false,
        showMessageRebind: false,
        idApremioRebind: 0,
        confirmado: false,
        observacionRebind: '',
        tabActive: "personas"
    });

    const [stateApremio, setStateApremio] = useState({
        numeroApremio: '',
        carpetaApremio: '',
        estadoApremio: '',
        caratulaApremio: ''
    });
    const [pendingChange, setPendingChange] = useState(false);
    const [stateAsignarApremio, setStateAsignarApremio] = useState({
        showApremios: false,
        reasignar: false,
        list: []
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['OrganoJudicial'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'OrganoJudicial',
            timeout: 0
        }
    });

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);

    const {hasPermission} = usePermissions();
    const canEditApremio = hasPermission(PERMISSIONS.APREMIO_EDIT);
    const canViewApremio = hasPermission(PERMISSIONS.APREMIO_VIEW);
    const canCancelCertificadoApremio = hasPermission(PERMISSIONS.CERTIFICADO_APREMIO_CANCEL);

    const mount = () => {
        if (state.id > 0) {
            FindCertificadoApremio();
        } else {
            dispatch(dataTaggerActionSet(state.processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
        }
    }
    useEffect(mount, [canViewApremio]);

    const [certificadoApremio_formValues, certificadoApremio_formHandle, , certificadoApremio_formSet] = useForm({
        idApremio: 0,
        idEstadoCertificadoApremio: 0,
        numero: '',
        idCuenta: 0,
        idInspeccion: 0,
        montoTotal: 0,
        fechaCertificado: null,
        fechaCalculo: null,
        fechaNotificacion: null,
        fechaRecepcion: null,
        pagoHabilitado: 0
    }, 'certificadoApremio_');

    useEffect(() => {
        if (!certificadoApremio_formValues.fechaNotificacion ||
            certificadoApremio_formValues.fechaNotificacion &&
            certificadoApremio_formValues.fechaRecepcion &&
            certificadoApremio_formValues.fechaNotificacion.getTime() > certificadoApremio_formValues.fechaRecepcion.getTime()) {
            certificadoApremio_formSet({
                ...certificadoApremio_formValues,
                fechaRecepcion: null
            });
        }
    }, [certificadoApremio_formValues.fechaNotificacion]);

    useEffect(() => {
        if (state.confirmado) ModifyRebindCertificadoApremio(state.idApremioRebind);
    }, [state.confirmado]);


    const [generateReporte,] = useReporte({
        callback: (reporte, buffer, message) => {
            if (buffer) {
                const extension = (reporte === 'CertificadoApremioJuicio') ? 'doc' : 'pdf';
                OpenObjectURL(`${reporte}.${extension}`, buffer);
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            }
        }
    });

    //handles
    const certificadoApremio_formHandleProxy = (event) => {
        certificadoApremio_formHandle(event);
        setPendingChange(true);
    }
    const handleClickGuardar = () => {
        if (state.id > 0) {
            ModifyCertificadoApremio();
        }
    }
    const handleClickAnular = () => {
        setState(prevState => {
            return {...prevState, showMessage: true};
        });
    }

    const handleClickNuevoApremio = () => {
        navigateWithFilters(`/apremio/new/${state.id}`);
    };
    const handleClickVerApremio = () => {
        navigateWithFilters(`/apremio/view/${state.entity.certificadoApremio.idApremio}`);
    };
    const handleClickAsignarApremio = () => {
        SearchApremios();
    };
    const handleClickReasignarApremio = () => {
        SearchApremios(true);
    };
    const handleClickAsignarApremioCancelar = () => {
        setStateAsignarApremio(prevState => {
            return {...prevState, showApremios: false};
        });
    }
    const handleClickAsignarApremioSelect = (row) => {
        let idApremio = parseInt(row.original.id);

        if (stateAsignarApremio.reasignar) {
            setStateAsignarApremio(prevState => {
                return {...prevState, showApremios: false};
            });
            ModifyRebindCertificadoApremio(idApremio);
            return;
        }

        certificadoApremio_formSet({
            ...certificadoApremio_formValues,
            idApremio: idApremio
        });
        FindApremio(idApremio);

        setStateAsignarApremio(prevState => {
            return {...prevState, showApremios: false};
        });
        setPendingChange(true);
    }

    const handleClickReporte = (reporte) => {
        const paramsReporte = {
            idCertificadoApremio: state.id
        }
        generateReporte(reporte, paramsReporte);
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindCertificadoApremio = (response) => {
        response.json()
            .then((data) => {

                if (state.mode !== OPERATION_MODE.VIEW && data.certificadoApremio.idEstadoCertificadoApremio === 403) {
                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Certificado cancelado, no se podrá modificar", () => {
                        dispatch(dataTaggerActionClear(state.processKey));
                        setState(prevState => {
                            return {...prevState, loading: false};
                        });
                        allowNavigation();
                        navigate({
                            to: `/certificado-apremio/${OPERATION_MODE.VIEW}/${state.id}`,
                            refresh: true,
                            replace: true,
                        });
                    });
                    return;
                }

                //deserialize date fields
                if (data.certificadoApremio.fechaCertificado) data.certificadoApremio.fechaCertificado = new Date(data.certificadoApremio.fechaCertificado);
                if (data.certificadoApremio.fechaCalculo) data.certificadoApremio.fechaCalculo = new Date(data.certificadoApremio.fechaCalculo);
                if (data.certificadoApremio.fechaNotificacion) data.certificadoApremio.fechaNotificacion = new Date(data.certificadoApremio.fechaNotificacion);
                if (data.certificadoApremio.fechaRecepcion) data.certificadoApremio.fechaRecepcion = new Date(data.certificadoApremio.fechaRecepcion);
                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.certificadoApremioPersonas.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setPendingChange(false);
                certificadoApremio_formSet({
                    idApremio: data.certificadoApremio.idApremio,
                    idEstadoCertificadoApremio: data.certificadoApremio.idEstadoCertificadoApremio,
                    numero: data.certificadoApremio.numero,
                    idCuenta: data.certificadoApremio.idCuenta,
                    idInspeccion: data.certificadoApremio.idInspeccion,
                    montoTotal: data.certificadoApremio.montoTotal,
                    fechaCertificado: data.certificadoApremio.fechaCertificado,
                    fechaCalculo: data.certificadoApremio.fechaCalculo,
                    fechaNotificacion: data.certificadoApremio.fechaNotificacion,
                    fechaRecepcion: data.certificadoApremio.fechaRecepcion,
                    pagoHabilitado: (data.certificadoApremio.pagoHabilitado) ? 1 : 0
                });

                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: data.archivos,
                    Observacion: data.observaciones,
                    Etiqueta: data.etiquetas
                }));

                if (data.certificadoApremio.idApremio > 0)
                    FindApremio(data.certificadoApremio.idApremio);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackSuccessFindApremio = (response) => {
        response.json()
            .then((data) => {

                setState(prevState => {
                    return {...prevState, loading: false};
                });

                setStateApremio(prevState => {
                    return {
                        ...prevState,
                        numeroApremio: data.apremio.numero,
                        carpetaApremio: data.apremio.carpeta,
                        caratulaApremio: data.apremio.caratula,
                        estadoApremio: data.apremio.estado
                    };
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }

    //funciones
    function FindCertificadoApremio() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CERTIFICADO_APREMIO,
            paramsUrl,
            null,
            callbackSuccessFindCertificadoApremio,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyCertificadoApremio() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Certificado actualizado correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                FindCertificadoApremio();
                //callbackSuccessFindCertificadoApremio(response);
            });
        };

        const dataBody = {
            certificadoApremio: {
                ...state.entity.certificadoApremio,
                idApremio: certificadoApremio_formValues.idApremio,
                idEstadoCertificadoApremio: certificadoApremio_formValues.idEstadoCertificadoApremio,
                numero: certificadoApremio_formValues.numero,
                idCuenta: certificadoApremio_formValues.idCuenta,
                idInspeccion: certificadoApremio_formValues.idInspeccion,
                montoTotal: certificadoApremio_formValues.montoTotal,
                fechaCertificado: certificadoApremio_formValues.fechaCertificado,
                fechaCalculo: certificadoApremio_formValues.fechaCalculo,
                fechaNotificacion: certificadoApremio_formValues.fechaNotificacion,
                fechaRecepcion: certificadoApremio_formValues.fechaRecepcion,
                pagoHabilitado: (certificadoApremio_formValues.pagoHabilitado === 1)
            },
            certificadoApremioItems: state.entity.certificadoApremioItems,
            certificadoApremioPersonas: state.entity.certificadoApremioPersonas.filter(f => f.state !== 'o'),
            archivos: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Etiqueta.filter(f => f.state !== 'o') : []
        };

        const paramsUrl = `/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CERTIFICADO_APREMIO,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function FindApremio(id) {

        if (!canViewApremio) {
            setStateApremio({
                numeroApremio: '',
                carpetaApremio: '',
                estadoApremio: '',
                caratulaApremio: ''
            });
            return;
        }

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/${id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.APREMIO,
            paramsUrl,
            null,
            callbackSuccessFindApremio,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyCancelCertificadoApremio() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Certificado anulado", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                FindCertificadoApremio();
            });
        };

        const paramsUrl = `/cancel/${state.id}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CERTIFICADO_APREMIO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function ModifyRebindCertificadoApremio(idApremio) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {

                    if (data.result === false) {
                        setState(prevState => {
                            return {...prevState, loading: false, showMessageRebind: true, idApremioRebind: idApremio};
                        });
                        return;
                    }

                    ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Certificado reasignado correctamente", () => {
                        dispatch(dataTaggerActionClear(state.processKey));
                        setState(prevState => {
                            return {...prevState, loading: false, idApremioRebind: 0, confirmado: false, observacionRebind: ''};
                        });
                        FindCertificadoApremio();
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false, idApremioRebind: 0, confirmado: false, observacionRebind: ''};
                    });
                });
        };

        const paramsUrl = `/apremio/rebind/${state.id}/${idApremio}`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CERTIFICADO_APREMIO,
            paramsUrl,
            {confirmado: state.confirmado, observacion: state.observacionRebind},
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function SearchApremios(reasignar = false) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {

                    data.forEach(x => {
                        if (x.fechaInicioDemanda) x.fechaInicioDemanda = new Date(x.fechaInicioDemanda);
                    });

                    const today = getDateNow();
                    data.sort((a, b) => (iif(b.fechaInicioDemanda, null, today)).getTime() - (iif(a.fechaInicioDemanda, null, today)).getTime());

                    const idApremioAsignado = parseInt(state.entity.certificadoApremio.idApremio);

                    setStateAsignarApremio(prevState => {
                        return {...prevState, showApremios: true, reasignar: reasignar, list: data.filter(f => parseInt(f.id) !== idApremioAsignado)};
                    });

                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const paramsUrl = `/cuenta/${state.entity.certificadoApremio.idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.APREMIO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs

        let entity = CloneObject(state.entity);

        if (typeEntity === 'CertificadoApremioPersona') {
            if (row.state === 'a') {
                entity.certificadoApremioPersonas.push(row);
            } else if (row.state === 'm') {
                const index = entity.certificadoApremioPersonas.indexOf(entity.certificadoApremioPersonas.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.certificadoApremioPersonas[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.certificadoApremioPersonas = entity.certificadoApremioPersonas.filter(f => f.id !== row.id);
                } else {
                    let item = entity.certificadoApremioPersonas.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        }

        setState(prevState => {
            return {...prevState, entity: entity};
        });
        setPendingChange(true);
    }

    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    const getDescOrganismoJudicial = (id) => {
        const row = getRowEntidad('OrganoJudicial', id);
        return (row) ? `${row.codigoOrganoJudicial} - ${row.departamentoJudicial}` : '';
    }

    const getDescFuero = (id) => {
        const row = getRowEntidad('OrganoJudicial', id);
        return (row) ? row.fuero : '';
    }

    const cellS = (props) => <div className='action'>
        <div onClick={(event) => handleClickAsignarApremioSelect(props.row)} className="link">
            <span className="material-symbols-outlined" title="Seleccionar">west</span>
        </div>
    </div>

    const tableColumnsApremio = [
        {
            Header: '',
            Cell: cellS,
            id: 'select',
            accessor: '',
            width: '5%',
            disableGlobalFilter: true,
            disableSortBy: true
        },
        {Header: 'Apremio', accessor: 'numero', width: '15%'},
        {
            Header: 'Inicio de demanda',
            Cell: (data) => (data.value) ? getDateToString(data.value, false) : '',
            accessor: 'fechaInicioDemanda',
            width: '25%'
        },
        {
            Header: 'Organismo judicial',
            Cell: (data) => getDescOrganismoJudicial(data.value),
            accessor: 'idOrganismoJudicial',
            width: '30%'
        },
        {
            Header: 'Fuero',
            Cell: (data) => getDescFuero(data.value),
            id: 'fuero',
            accessor: 'idOrganismoJudicial',
            width: '25%'
        }
    ];

    return (
        <>

            <Loading visible={state.loading}></Loading>

            {state.showMessage &&
                <MessageModal
                    title={"Confirmación"}
                    message={"¿Está seguro de anular el certificado?"}
                    onDismiss={() => {
                        setState(prevState => {
                            return {...prevState, showMessage: false};
                        });
                    }}
                    onConfirm={() => {
                        const id = state.rowId;
                        setState(prevState => {
                            return {...prevState, showMessage: false};
                        });
                        ModifyCancelCertificadoApremio();
                    }}
                />
            }

            {state.showMessageRebind &&
                <ReasignarApremioModal
                    onDismiss={() => {
                        setState(prevState => {
                            return {...prevState, loading: false, showMessageRebind: false, idApremioRebind: 0, confirmado: false, observacionRebind: ''};
                        });
                    }}
                    onConfirm={(observacion) => {
                        setState(prevState => {
                            return {...prevState, showMessageRebind: false, confirmado: true, observacionRebind: observacion};
                        });
                    }}
                />
            }

            {stateAsignarApremio.showApremios &&
                <Modal
                    size="lg"
                    title="Apremios"
                    onEscape={() => handleClickAsignarApremioCancelar()}
                    body={(
                                <TableCustom
                                    showFilterGlobal={true}
                                    className={'TableCustomBase'}
                                    columns={tableColumnsApremio}
                                    data={stateAsignarApremio.list}
                                />
                    )}
                    footer={(
                                <div className='footer-action-container'>
                                    <button className="btn btn-outline-primary float-end" data-dismiss="modal"
                                            onClick={() => handleClickAsignarApremioCancelar()}>Cancelar
                                    </button>
                                </div>
                    )}
                />
            }

            <div className='section-frames'>

                <div className='section-main'>

                    <SectionHeading
                        titles={[
                            {title: 'Legales'},
                            {title: 'Certificados', url: '/certificados-apremio',},
                            {title: params.mode === OPERATION_MODE.NEW ? 'Nuevo' : `Número: ${state.entity.certificadoApremio.numero}`}
                        ]}
                        title={
                            <>
                                Certificado (
                                <span
                                    className='text-heading-selecction'>Número: {state.entity.certificadoApremio.numero}</span>
                                )
                            </>
                        }
                    />

                    <section className='section-accordion'>
                        <div className="m-top-20 m-bottom-20">
                            <Accordion title="Datos" startOpen={true}>
                                <div className='row form-basic'>
                                    <div className="row">
                                        <div className="mb-3 col-12 col-md-2">
                                            <label htmlFor="numero" className="form-label">Número</label>
                                            <input
                                                name="numero"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.numero}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="mb-3 col-12 col-md-2">
                                            <label htmlFor="idEstadoCertificadoApremio"
                                                   className="form-label">Estado</label>
                                            <InputLista
                                                name="idEstadoCertificadoApremio"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.idEstadoCertificadoApremio}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={true}
                                                lista="EstadoCertificadoApremio"
                                            />
                                        </div>
                                        <div className="mb-3 col-12 col-md-2">
                                            <FormLabel htmlFor="pagoHabilitado" required>Estado de deuda</FormLabel>
                                            <Select
                                                name="pagoHabilitado"
                                                className="form-control"
                                                value={certificadoApremio_formValues.pagoHabilitado}
                                                options={[
                                                    { value: 0, label: 'Bloqueado' },
                                                    { value: 1, label: 'Desbloqueado' },
                                                ]}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                        </div>
                                        <div className="mb-3 col-12 col-md-2">
                                            <label htmlFor="idCuenta" className="form-label">Cuenta</label>
                                            <InputCuenta
                                                name="idCuenta"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.idCuenta}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="mb-3 col-12 col-md-2">
                                            <label htmlFor="idInspeccion" className="form-label">Número de
                                                inspección</label>
                                            <InputLista
                                                name="idInspeccion"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.idInspeccion}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                lista="InspeccionCertificadoApremio"
                                            />
                                        </div>
                                        <div className="mb-3 col-12 col-md-2">
                                            <label htmlFor="montoTotal" className="form-label">Total deuda</label>
                                            <InputNumber
                                                type="number"
                                                name="montoTotal"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.montoTotal}
                                                onChange={certificadoApremio_formHandleProxy}
                                                precision={2}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6 col-md-2">
                                            <label htmlFor="fechaCertificado" className="form-label">Fecha</label>
                                            <DatePickerCustom
                                                name="fechaCertificado"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.fechaCertificado}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-6 col-md-2">
                                            <label htmlFor="fechaCalculo" className="form-label">Fecha
                                                cálculo</label>
                                            <DatePickerCustom
                                                name="fechaCalculo"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.fechaCalculo}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-6 col-md-2">
                                            <label htmlFor="fechaNotificacion" className="form-label">Fecha
                                                notificación</label>
                                            <DatePickerCustom
                                                name="fechaNotificacion"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.fechaNotificacion}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                        </div>
                                        <div className="col-6 col-md-2">
                                            <label htmlFor="fechaRecepcion" className="form-label">Fecha
                                                recepción</label>
                                            <DatePickerCustom
                                                name="fechaRecepcion"
                                                placeholder=""
                                                className="form-control"
                                                value={certificadoApremio_formValues.fechaRecepcion}
                                                onChange={certificadoApremio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW || !certificadoApremio_formValues.fechaNotificacion}
                                                minValue={certificadoApremio_formValues.fechaNotificacion}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Accordion>

                            {canViewApremio &&
                                <>
                                    <div className="m-top-20">
                                        <Accordion title="Apremio">
                                            <div className='row form-basic'>
                                                <div className="col-12 col-md-2">
                                                    <label htmlFor="numeroApremio" className="form-label">Número de
                                                        apremio</label>
                                                    <input
                                                        name="numeroApremio"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={stateApremio.numeroApremio}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label htmlFor="carpetaApremio"
                                                           className="form-label">Carpeta</label>
                                                    <input
                                                        name="carpetaApremio"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={stateApremio.carpetaApremio}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <label htmlFor="caratulaApremio"
                                                           className="form-label">Carátula</label>
                                                    <input
                                                        name="caratulaApremio"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={stateApremio.caratulaApremio}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label htmlFor="estadoApremio" className="form-label">Estado</label>
                                                    <input
                                                        name="estadoApremio"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={stateApremio.estadoApremio}
                                                        disabled={true}
                                                    />
                                                </div>
                                                {
                                                    /*
                                                    <div className='col-12 col-md-2 m-top-20'>
                                                        <button className="btn task-button m-top-10" onClick={ (event) => handleClickReporte("CertificadoApremioJuicio") }>Juicio apremio</button>
                                                        </div>
                                                    */
                                                }
                                            </div>
                                        </Accordion>
                                    </div>
                                </>}

                                <div className="m-top-20">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Certificado Apremio"
                                            processKey={state.processKey}
                                            entidad="CertificadoApremio"
                                            idEntidad={state.id}
                                            disabled={(state.mode === OPERATION_MODE.VIEW)}
                                            onChange={(row) => setPendingChange(true)}
                                        />
                                    </Accordion>
                                </div>

                            <Tabs
                                id="tabs-apremio"
                                activeKey={state.tabActive}
                                className="m-top-20"
                                onSelect={(tab) => SetTabActive(tab)}
                            >
                                <Tab eventKey="personas" title="Personas">
                                    <div className='tab-panel'>
                                        <CertificadoApremioPersonaGrid
                                            processKey={state.processKey}
                                            disabled={state.mode === OPERATION_MODE.VIEW}
                                            data={{
                                                idCertificadoApremio: state.entity.certificadoApremio.id,
                                                list: state.entity.certificadoApremioPersonas
                                            }}
                                            onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                        />
                                    </div>
                                </Tab>
                                <Tab eventKey="saldos" title="Saldos certificados">
                                    <div className='tab-panel'>
                                        <CertificadosApremioItemGrid
                                            data={{
                                                idCertificadoApremio: state.entity.certificadoApremio.id,
                                                list: state.entity.certificadoApremioItems
                                            }}
                                        />
                                    </div>
                                </Tab>
                                <Tab eventKey="titulos" title="Títulos ejecutivos">
                                    <div className='tab-panel'>
                                        <CertificadoApremioTituloGrid
                                            idCertificadoApremio={state.entity.certificadoApremio.id}
                                            idFirmaDigitalTituloEjecutivo={state.entity.certificadoApremio.idFirmaDigitalTituloEjecutivo}
                                            pendingChange={pendingChange}
                                            refetch={FindCertificadoApremio}
                                        />
                                    </div>
                                </Tab>
                            </Tabs>

                        </div>

                    </section>

                </div>

            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <FooterButtonVolver pendingChange={pendingChange} processKey={state.processKey}
                                        filters={previousFilters} to="/certificados-apremio"
                                        allowNavigation={allowNavigation}/>
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <>
                            {canCancelCertificadoApremio &&
                                <button className="btn action-button m-left-10 float-start"
                                        onClick={(event) => handleClickAnular()}>Anular</button>
                            }
                            <button
                                className={pendingChange ? "btn action-button-fill float-end" : "btn action-button-fill btn-disabled float-end"}
                                onClick={(event) => handleClickGuardar()}
                                disabled={!pendingChange}
                            >
                                Guardar
                            </button>
                            {!state.entity.certificadoApremio.idApremio > 0 && canEditApremio &&
                                state.entity.certificadoApremio.idEstadoFirmaTituloEjecutivo === ESTADOS_FIRMA.FIRMADO &&
                                <>
                                    <button className="btn btn-primary m-right-10 float-end"
                                            onClick={(event) => handleClickNuevoApremio()}>Nuevo apremio
                                    </button>
                                    <button className="btn btn-outline-primary m-right-10 float-end"
                                            onClick={(event) => handleClickAsignarApremio()}>Asignar apremio
                                    </button>
                                </>
                            }
                        </>
                    }
                    {state.entity.certificadoApremio.idApremio > 0 && canViewApremio &&
                        <>
                            <button className="btn btn-primary m-right-10 float-end"
                                    onClick={(event) => handleClickVerApremio()}>Ver apremio
                            </button>
                        </>
                    }
                    {state.entity.certificadoApremio.idApremio > 0 && canEditApremio &&
                        <button className="btn btn-outline-primary m-right-10 float-end"
                                onClick={(event) => handleClickReasignarApremio()}>Reasignar apremio
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default CertificadoApremioView;